import React from "react";
import { observer } from "mobx-react";
import { Hidden, Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { assetUrl } from "../../utils/misc";

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    marginTop: "auto",
    paddingBottom: theme.spacing(2),
  },
  footer__element: {
    textAlign: "center",
    marginTop: theme.spacing(2)
  },
  brandLogo: {
    display: "inline-block",
  },
  LogoImg: {
    width: 48,
    height: 48,
  }
}))

const Footer = observer(() => {
  const classes = useStyles();

  return (
    <Hidden smDown implementation="css">
      <footer className={classes.footer}>
        <div className={classes.footer__element}>
          <div className={classes.brandLogo}>
            <img src={assetUrl("/images/logo-icon.png")} className={classes.LogoImg} />
          </div>
        </div>
        <div className={classes.footer__element}>
          <Typography variant="subtitle2" color="textSecondary" display="inline">Powered by Eyedog Digital Wayfinding</Typography>
        </div>
      </footer >
    </Hidden>
  );
});

export default Footer;